import React from 'react';
import { CheckIcon } from 'lucide-react';
import { day45Outcomes, whyReasons } from '../data/salesPage';
export function WhySection() {
  return <section aria-labelledby="por-que" className="bg-ink" data-id="element-249" data-mp="13vjdgd8s8gue">
      <div className="mx-auto max-w-5xl px-5 py-20 sm:py-28" data-id="element-250" data-mp="18u2z0cjgrqm8">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-20" data-id="element-251" data-mp="1dl2xhm88egqu">
          <div data-id="element-252" data-mp="1dme21o9i3sj0">
            <h2 id="por-que" className="font-display text-5xl font-black uppercase leading-none text-bone sm:text-6xl" data-id="element-253" data-mp="1dmw81clytl44">
              ¿Por qué <span className="text-lime" data-id="element-254" data-mp="1ml843u5lpb3y">45 días?</span>
            </h2>
            <p className="mt-6 text-lg text-bone-muted" data-id="element-255" data-mp="1mnlwfv8wc97t">Porque necesitás tiempo suficiente para:</p>
          </div>
          <ol className="flex flex-wrap content-start gap-2.5 lg:pt-3" data-id="element-256" data-mp="1wjoyl13r07ur">
            {whyReasons.map(reason => <li key={reason} className="rounded-full bg-ink-raised px-4 py-2 font-display text-lg font-bold text-bone ring-1 ring-ink-line" data-id="element-257" data-mp="3td0l77g46kge">
                {reason}
              </li>)}
          </ol>
        </div>

        <div className="mt-12 max-w-2xl space-y-2 text-lg" data-id="element-258" data-mp="2ih7wdo5i9jrm">
          <p className="text-bone-muted" data-id="element-259" data-mp="2doeq2vue23df">No se trata de cambiar tu cuerpo de un día para otro.</p>
          <p className="font-display text-2xl font-bold text-bone" data-id="element-260" data-mp="28pbyoe7bzvnx">Se trata de comenzar un proceso que puedas sostener.</p>
        </div>

        <div className="mt-24 rounded-[2rem] border border-ink-line bg-ink-raised p-8 sm:p-12" data-id="element-261" data-mp="24ptbtcvy9aig">
          <h2 className="font-display text-4xl font-black uppercase leading-tight text-bone sm:text-5xl" data-id="element-262" data-mp="31dzbdle0lcpv">
            Imaginá estar en el <span className="text-lime" data-id="element-263" data-mp="2wdbpfe4n7m2i">día 45…</span>
          </h2>
          <p className="mt-4 text-lg text-bone-muted" data-id="element-264" data-mp="2schwg6ccfh2r">Mirando hacia atrás. Y saber que:</p>
          <ul className="mt-8 grid gap-x-10 gap-y-4 sm:grid-cols-2" data-id="element-265" data-mp="2ndomup06ga7v">
            {day45Outcomes.map(item => <li key={item} className="flex items-start gap-3 text-lg text-bone" data-id="element-266" data-mp="1h08qincbq160">
                <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-lime" strokeWidth={3} aria-hidden="true" data-id="element-267" data-mp="1byrsr0p4yutn" />
                {item}
              </li>)}
          </ul>
          <p className="mt-10 font-display text-xl font-bold text-lime" data-id="element-268" data-mp="1igcqznvust27">Eso es lo que queremos que te lleves.</p>
        </div>
      </div>
    </section>;
}